import { useCallback } from 'react';
import useAuthenticationFactorPromote from './useAuthenticationFactorPromote';
import useEmailVerificationPromote from './useEmailVerificationPromote';
import { GenericTaskItem, TaskData, TaskActionData } from '../GenericTaskList';

export interface UseAlertPromoteResult {
  items: GenericTaskItem[];
  handleAction: (item: TaskData & TaskActionData) => void;
  handleSkip: (item: TaskData & TaskActionData) => void;
}

function useAlertPromote(): UseAlertPromoteResult {
  const authFactor = useAuthenticationFactorPromote();
  const emailVerification = useEmailVerificationPromote();

  const handleAction = useCallback(
    (item: TaskData & TaskActionData) => {
      if (item.id === 'recovery-codes') {
        authFactor.handleAction();
      } else if (item.id === 'verify-email') {
        emailVerification.handleAction();
      }
    },
    [authFactor, emailVerification],
  );

  const handleSkip = useCallback(
    (item: TaskData & TaskActionData) => {
      if (item.id === 'verify-email') {
        emailVerification.handleSkip();
      }
    },
    [emailVerification],
  );

  const items: GenericTaskItem[] = [];

  if (authFactor.item) {
    items.push(authFactor.item);
  }

  if (emailVerification.item) {
    items.push(emailVerification.item);
  }

  return {
    items,
    handleAction,
    handleSkip,
  };
}

export default useAlertPromote;
